import { render, staticRenderFns } from "./EvidenceSidebar.vue?vue&type=template&id=819792c2&"
import script from "./EvidenceSidebar.vue?vue&type=script&lang=js&"
export * from "./EvidenceSidebar.vue?vue&type=script&lang=js&"
import style0 from "./EvidenceSidebar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports